import React from 'react';
import Chart from 'react-apexcharts';
import { Layout } from '../../configs/ui/constant';
// const options = {
//   plotOptions: {
//     radialBar: {
//       hollow: {
//         margin: 0,
//         size: "70%",
//         background: "rgba(41,52,80,0.2)",
//       },
//       track: {
//         dropShadow: {
//           enabled: true,
//           top: 2,
//           left: 0,
//           blur: 4,
//           opacity: 0.15,
//         },
//       },
//       dataLabels: {
//         name: {
//           show: false,
//         },
//         value: {
//           textAnchor: "middle",
//           offsetX: 0,
//           offsetY: 0,
//           color: Layout.primary,
//           show: true,
//           fontFamily: "GSB",
//           fontSize: "1rem",
//         },
//       },
//     },
//   },
//   fill: {
//     type: "gradient",
//     gradient: {
//       shade: "light",
//       type: "vertical",
//       gradientToColors: [Layout.secondary],
//       stops: [0, 100],
//     },
//   },
//   stroke: {
//     lineCap: "round",
//   },
//   colors: [Layout.primary],
// };
const options = {
   plotOptions: {
      radialBar: {
         track: {
            dropShadow: {
               enabled: true,
               top: 2,
               left: 0,
               blur: 4,
               opacity: 0.15,
            },
         },
         dataLabels: {
            name: {
               show: false,
            },
            value: {
               textAnchor: 'middle',
               offsetX: 0,
               offsetY: 0,
               color: 'darkgrey',
               show: true,
               fontFamily: 'GSB',
               fontSize: '1rem',
            },
         },
      },
   },
   series: [70],
   labels: ['Progress'],
   colors: [Layout.primary],
   // stroke: {
   //   lineCap: "round",
   // },
};

const Circle = ({ series }) => {
   return (
      <Chart
         options={options}
         series={series}
         type={'radialBar'}
         height={'200'}
      />
   );
};

export default Circle;
